import { Modal, QRCode, Typography } from "antd";
import { buildIdentifierQrPayload } from "../utils/connectScanParser";

const { Text } = Typography;

interface IdentifierQrModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  payload: Record<string, string>;
  caption?: string;
  hint?: string;
}

export default function IdentifierQrModal({
  open,
  onClose,
  title,
  payload,
  caption,
  hint,
}: IdentifierQrModalProps) {
  const qrValue = buildIdentifierQrPayload(payload);

  return (
    <Modal title={title} open={open} onCancel={onClose} footer={null} destroyOnClose centered>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16 }}>
        <QRCode value={qrValue} size={220} />
        {caption ? (
          <Text strong style={{ textAlign: "center", fontSize: 16 }}>
            {caption}
          </Text>
        ) : null}
        {hint ? (
          <Text type="secondary" style={{ textAlign: "center" }}>
            {hint}
          </Text>
        ) : null}
      </div>
    </Modal>
  );
}
